import Album from '../components/Album';
import showcases from '../mocks/showcases.json';
import Breadcrumb from '../components/Breadcrumb';
import TitlePage from '../components/TitlePage';

const Showcase = () => {
    return (
        <>
            <Breadcrumb history={[{ title: 'Home', to: '/' }]} current='Showcase' />

            <section className='services'>
                <TitlePage title='Showcase' />
                <div className='container'>
                    <div className='row gy-4'>
                        <div className='col-12 d-flex' data-aos='fade-up' data-aos-delay='100'>
                            <div className='row service-item'>
                                <div className='col-md-6 text-center'>
                                    <img src={'img/showcase/glami_fashion_hub.webp'} className='img-fluid img-cover' alt='' />
                                </div>
                                <div className='col-md-6 mt-3 mt-md-0'>
                                    <h4>GLAMI FASHION HUB</h4>
                                    <p>
                                        Nasce il GLAMI FASHION HUB, la manifestazione di Roma dove moda e arte si incontrano. Lo spazio è
                                        dedicato a designer emergenti, professionisti del settore, studenti e a tutti gli appassionati.
                                        L’evento è studiato per intrattenere il pubblico attraverso una serie di attività didattiche, di
                                        scambio e ludiche.
                                    </p>
                                    <p className='mt-2'>
                                        La prima edizione ha registrato più di mille eventi in soli 2 giorni. Qui potrai dar luce al tuo
                                        brand emergente e farti notare! Il team di Glami ti supporterà durante tutto l’evento.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 d-flex' data-aos='fade-up' data-aos-delay='100'>
                            <div className='row service-item'>
                                <div className='col-md-6 text-center'>
                                    <img src={'img/showcase/cover.webp'} className='img-fluid img-cover' alt='' />
                                </div>
                                <div className='col-md-6 mt-3 mt-md-0'>
                                    <p>
                                        La community Glami è sempre in espansione, per questo studiamo nuovi modi per mettere in
                                        comunicazione i giovani fashion designer ed il pubblico della moda.
                                    </p>
                                    <p className='mt-2'>
                                        Il servizio di showcase è l’occasione perfetta per pubblicizzare il tuo brand, un evento aperto al
                                        pubblico e uno spazio di networking dove stringere trovare nuovi acquirenti e ampliare la tua rete
                                        di contatti.
                                        <br />
                                    </p>
                                    <p className='mt-2'>
                                        La prima edizione del nostro showcase ha riscosso un gran successo: abbiamo accolto più di 200
                                        ingressi!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='section album'>
                <div className='container section-title' data-aos='fade-up'>
                    <h2>Album</h2>
                </div>

                <div className='container'>
                    <div className='row gy-4' data-aos='fade-up' data-aos-delay='100'>
                        {showcases.map(item => (
                            <Album title={item.title} to={`gallery/${item.id}`} path={item.path} alt={item.alt} />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};
export default Showcase;
